export default "__VITE_ASSET__aZoyZU$t__"